import React from 'react';
import {Typography, Tag, Tooltip} from 'antd';

import {ExclamationCircleOutlined, WechatOutlined, TeamOutlined} from '@/icons';

import {format, FORMAT_LONG} from '@/util/dateUtils';

const {Text} = Typography;

const columnDefines = () => ({
    customerName: {
        title: '客户',
        dataIndex: 'customerName',
        render: (text, record) => {
            const {customerName, corpName, customerType} = record;
            let corp = '';
            if (customerType == 2) {
                corp = ' @' + corpName;
            }
            return (
                <>
                    {customerName}
                    <Text style={{color: '#096dd9', fontSize: '12px'}}>{corp}</Text>
                </>
            );
        },
    },
    customerType: {
        title: '客户类型',
        dataIndex: 'customerType',
        render: text => {
            if (text == 2) {
                return (
                    <Tag color="blue" icon={<TeamOutlined />}>
                        企业成员
                    </Tag>
                );
            } else if (text == 1) {
                return (
                    <Tag color="green" icon={<WechatOutlined />}>
                        微信客户
                    </Tag>
                );
            }
            return '';
        },
    },
    changeType: {
        title: '流失类型',
        dataIndex: 'changeType',
        render: (text, record) => {
            const {reason} = record;
            let title = '失败原因：' + reason;
            if (text == 'transfer_fail') {
                return (
                    <>
                        <Tag color="red">交接失败</Tag>
                        <Tooltip title={title}>
                            <ExclamationCircleOutlined />
                        </Tooltip>
                    </>
                );
            } else if (text == 'del_follow_user') {
                return <Tag color="magenta">客户删除</Tag>;
            } else if (text == 'del_external_contact') {
                return <Tag color="volcano">删除客户</Tag>;
            }
            return '';
        },
    },
    userName: {
        title: '员工',
        dataIndex: 'userName',
        render: (text, record) => {
            return (
                <div>
                    {text}
                    <span>({record.extId})</span>
                </div>
            );
        },
    },
    reason: {
        title: '失败原因',
        dataIndex: 'reason',
        render: (text, record) => {
            const {changeType, reason} = record;
            if (changeType == 'transfer_fail') {
                return reason;
            }
            return '';
        },
    },
    timeStamp: {
        title: '时间',
        dataIndex: 'timeStamp',
        render: text => {
            return <Text>{format(text * 1000, FORMAT_LONG)}</Text>;
        },
    },
});

export function getColumns(keys) {
    return keys.map(key => columnDefines()[key]).filter(Boolean);
}
